/**
 * @param {PicklistItem} item
 * @param {HTMLTemplateElement} template
 * @param {Function} removeItem
 */
const createRow = (item, template, removeItem) => {
  // fallback to first child for IE as content is not defined using the polyfills
  // For some reason adding fragments (with the included text nodes) fails later on, so get primary node
  const content =
    template.firstElementChild || template.content.firstElementChild;
  const row = content.cloneNode(true);
  row
    .querySelector('.c-picklist-product-image')
    .setAttribute('src', item.thumbnail);
  row.querySelector('.c-picklist-product-link').setAttribute('src', item.url);
  row.querySelector('.c-picklist-product-title').innerHTML = item.name;
  row.querySelector('.c-picklist-product-label1').innerHTML = item.label1;
  // row.querySelector('.c-picklist-product-label2').innerHTML = item.label2;
  if (item.articleNumber)
    row.querySelector('.c-picklist-product-articlenumber').innerHTML =
      item.articleNumber;
  else
    row.querySelector(
      '.c-picklist-product-articlenumber',
    ).parentElement.style.display = 'none';
  row
    .querySelector('.c-picklist-product-remove')
    .addEventListener('click', () => removeItem(item));
  return row;
};

/**
 *
 * @param {HtmlElement} itemsElement
 * @param items
 */
const updateNumItems = (itemsElement, items) => {
  if (!itemsElement) return;
  const { template } = itemsElement.dataset;
  itemsElement.innerHTML = template.replace('{0}', items.length);
};

const updateInfoRow = (infoRow, items) => {
  updateNumItems(infoRow.querySelector('.c-picklist-items-text'), items);
  if (items.length > 0) {
    infoRow.setAttribute('style', '');
  } else {
    infoRow.setAttribute('style', 'display: none');
  }
};

/**
 *
 * @param {PicklistItem[]}items
 * @param {function(PicklistItem)} removeItem
 * @returns {{update: (function(): undefined)}|{update: update}}
 * @constructor
 */
const PicklistPage = (items, removeItem, clear) => {
  const template = document.getElementById('picklist-product-template');
  const noItemsElement = document.querySelector('.c-picklist-page-noitems');
  const itemsContainer = document.querySelector('.c-picklist-page-items');
  const pageInfoRow = document.querySelector('.c-picklist-page-inforow');
  const clearButton = document.querySelector('.c-picklist-clear');

  // just exit out with a void update if not on picklist page;
  if (!template) return { update: () => undefined };

  clearButton.addEventListener('click', clear);

  /**
   * updates page based on items
   * @param {PicklistItem[]}items
   */
  const update = items => {
    const fragment = document.createDocumentFragment();
    const rows = items.map(item => createRow(item, template, removeItem));

    // IE fallback doesnt handle append
    if (fragment.append) {
      fragment.append(...rows);
    } else {
      for (var i = 0; i < rows.length; i++) {
        fragment.appendChild(rows[i]);
      }
    }
    itemsContainer.innerHTML = '';
    itemsContainer.appendChild(fragment);

    if (rows.length > 0) {
      noItemsElement.setAttribute('style', 'display: none');
    } else {
      noItemsElement.setAttribute('style', '');
    }
    updateInfoRow(pageInfoRow, items);
  };
  update(items);
  return { update };
};

export default PicklistPage;
